import $ from 'jquery'
import { trace } from "rytm-helpers"

export const initDropdownFix = () => {
  const list = [...document.querySelectorAll(".dropdown")]
  list.forEach((el) => {
    // trace("init dropdown", el)
    // $(el).dropdown('toggle')
    // $(el).dropdown()
  })
}
